import { TransactionHistoryRequestModel } from "app/based/baseApiModel/baseTransactionHistory/TransactionHistoryRequestModel";
import { TypeOfTravelSimEnum } from "utils/enums/TypeOfTravelSimEnum";

export class TravelSimRegistrationRequestModel extends TransactionHistoryRequestModel {
  carrierCode?: Array<string>;
  code?: string;
  created?: Record<string, unknown>[];
  fromDate?: string;
  limit?: number;
  page?: number;
  pagination?: boolean;
  phoneNumber?: string;
  status?: number;
  toDate?: string;
  package?: string;
  packageCode?: Array<string>;
  type?: number;
  simType?: number;
  nation?: string;
  typeofSim?: TypeOfTravelSimEnum;
  storeCodes?: Array<string>;
  userRef?: Array<string>;
  partnerCodes?: Array<string>;
  order?: string;
  isdnOrIccid?: string;
  isOnlyStore?: string;
  providerCode?: string;
  serviceCode?: string;
  serial?: string;
  buyerPhone?: string;
  transRef?: string;
  supplierRefCode?: string;
  constructor(data?: Partial<TravelSimRegistrationRequestModel>) {
    super();
    this.status = data?.status;
    this.code = data?.code;
    this.carrierCode = data?.carrierCode;
    this.phoneNumber = data?.phoneNumber;
    this.page = data?.page;
    this.limit = data?.limit;
    this.pagination = data?.pagination;
    this.fromDate = data?.fromDate;
    this.simType = data?.simType;
    this.toDate = data?.toDate;
    this.isdnOrIccid = data?.isdnOrIccid;
    this.package = data?.package;
    this.created = data?.created;
    this.nation = data?.nation;
    this.type = data?.type;
    this.typeofSim = data?.typeofSim;
    this.storeCodes = data?.storeCodes;
    this.userRef = data?.userRef;
    this.partnerCodes = data?.partnerCodes;
    this.order = data?.order;
    this.isOnlyStore = data?.isOnlyStore;
    this.providerCode = data?.providerCode;
    this.serviceCode = data?.serviceCode;
    this.packageCode = data?.packageCode;
    this.serial = data?.serial;
    this.buyerPhone = data?.buyerPhone;
    this.transRef = data?.transRef;
    this.supplierRefCode = data?.supplierRefCode;
  }
}
